import { yupResolver } from '@hookform/resolvers/yup';
import { FC, useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { AdminSettingsLayout } from '../../../../common/components';
import { useFaqs } from '../../../../common/hooks';
import { payloadFromSchema, schema } from './CreateFaq';
import BankaccountForm from './FaqForm';

interface Props {}

const createFormData = (data: any) => {
    return data;
};

const UpdateFaq: FC<Props> = () => {
    const { updateFaq, loading, error } = useFaqs();
    const navigate = useNavigate();
    const location = useLocation();

    const faqData = location.state?.data;

    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: useMemo(() => faqData && createFormData(faqData), [faqData]),
    });

    useEffect(() => {
        if (faqData) {
            reset(createFormData(faqData));
        }
        // eslint-disable-next-line
    }, []);

    const onSubmit = async (data: any) => {
        const payload = payloadFromSchema(data);

        try {
            await updateFaq(faqData.id, payload);
            navigate('/settings/faq');
        } catch (err) {
            // try again...
        }
    };

    return (
        <AdminSettingsLayout title="Alterar tópico de ajuda">
            <BankaccountForm
                control={control}
                handleSubmit={handleSubmit}
                onSubmit={onSubmit}
                errors={errors} // client-side validation
                error={error} // server-side error
                loading={loading}
                isEdit={true}
            />
        </AdminSettingsLayout>
    );
};

export default UpdateFaq;
